import React from "react";
import { StageList, CreateStage } from "./index";
import EditStage from "./pages/EditStage";
import ViewStage from "./pages/ViewStage";

const stageRoutes = [
  {
    path: "/stage",
    element: <StageList />,
  },
  {
    path: "/stage/create",
    element: <CreateStage />,
  },
  {
    path: "/stage/view/:id",   // ✅ ADD
    element: <ViewStage />,
  },
  {
    path: "/stage/edit/:id",
    element: <EditStage />
  },
];

export default stageRoutes;
